import { BorderOutlined, CheckSquareOutlined } from '@ant-design/icons';
import { not } from 'ramda';
import React from 'react';
import classNames from 'classnames';
import withUser from '../../../../../../withUser';

const logoChecked = {
  checked: <CheckSquareOutlined />,
  unchecked: <BorderOutlined />
};

const DefaultValuesCheck = ({ onChangeIsDefaultValue, checked, userCanEdit }) => {
  if (not(userCanEdit)) return null;
  const format = checked ? 'checked' : 'unchecked';
  return (
    <div>
      <span onClick={() => userCanEdit && onChangeIsDefaultValue(!checked)}>
        {logoChecked[format]}&nbsp;
      </span>
      <span
        className={classNames('text-xs inline-block align-middle cursor-pointer', { 'cursor-not-allowed': !userCanEdit })}
        onClick={() => userCanEdit && onChangeIsDefaultValue(!checked)}
      >
        Valeur par défaut
      </span>
    </div>
  );
};

export default withUser(DefaultValuesCheck);
